import logo from "../../assets/images/agi-logo.png";
import React, { useState, useEffect } from "react";
import axios from "axios";

const About = () => {
  const [about, setAbout] = useState([]);

  useEffect(() => {
    getAllAbout();
  }, []);

  const getAllAbout = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}aboutUs`
      );
      setAbout(response.data.about);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section id="about" className="md:pt-14 pt-20  py-0 mt-14">
      <div className="bg-[#EFEAE5] py-16 md:py-24 ">
        {about.map((abt, i) => (
          <div
            className="w-full text-slate-800 md:mx-10 px-6 md:px-20  mb-6 "
            data-aos="fade-down"
            data-aos-duration="800"
            key={i}
          >
            <h3 className="font-poppins text-3xl md:text-3xl font-medium text-center ">
              Tentang <span className="text-secondary"> Kami</span>
            </h3>
            <div className="w-full flex mt-12 mb-8">
              <img
                src={abt.url}
                alt="Anjas Logo"
                className="w-18 h-14 mx-auto"
              />
            </div>
            <p className="font-poppins font-light text-slate-600 text-sm mt-4 text-center">
              {abt.caption}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
